import { render } from "./Announcement.vue?vue&type=template&id=65d9000b&scoped=true&ts=true"
import script from "./Announcement.ts?vue&type=script&lang=ts"
export * from "./Announcement.ts?vue&type=script&lang=ts"

import "./Announcement.scss?vue&type=style&index=0&id=65d9000b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d9000b"]])

export default __exports__